module.exports = __webpack_public_path__ + "static/media/qq.caadc819.jpg";